import { useInstancesByClassName } from 'hive-react-utils';
import { Room } from '../types';

export function useRooms(): Room[] | undefined {
  return useInstancesByClassName('acs', 'room');
}
